import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth-context";

const VISITOR_MSG = "Hi Zola, I'd like to know more about Zola Rewards.";
const PUBLIC_PATHS = ["/", "/login/customer", "/join"];

export const WhatsAppIcon = ({ className }) => (
  <svg viewBox="0 0 32 32" className={className} fill="currentColor" aria-hidden="true">
    <path d="M16.004 3C8.82 3 3 8.82 3 16c0 2.293.6 4.533 1.74 6.507L3 29l6.66-1.707A12.94 12.94 0 0 0 16.004 29C23.18 29 29 23.18 29 16S23.18 3 16.004 3Zm0 23.6c-2.04 0-4.04-.547-5.787-1.587l-.413-.247-3.953 1.013 1.053-3.853-.267-.427A10.55 10.55 0 0 1 5.4 16c0-5.84 4.76-10.6 10.604-10.6C21.84 5.4 26.6 10.16 26.6 16s-4.76 10.6-10.596 10.6Zm5.813-7.933c-.32-.16-1.893-.933-2.187-1.04-.293-.107-.507-.16-.72.16-.213.32-.827 1.04-1.013 1.253-.187.213-.373.24-.693.08-.32-.16-1.347-.493-2.567-1.587-.947-.84-1.587-1.88-1.773-2.2-.187-.32-.02-.493.14-.653.147-.147.32-.373.48-.56.16-.187.213-.32.32-.533.107-.213.053-.4-.027-.56-.08-.16-.72-1.733-.987-2.373-.26-.627-.52-.54-.72-.547h-.613c-.213 0-.56.08-.853.4-.293.32-1.12 1.093-1.12 2.667 0 1.573 1.147 3.093 1.307 3.307.16.213 2.253 3.44 5.46 4.827.763.33 1.36.527 1.823.673.767.244 1.464.21 2.016.127.615-.092 1.893-.773 2.16-1.52.267-.747.267-1.387.187-1.52-.08-.133-.293-.213-.613-.373Z" />
  </svg>
);

export function useWhatsAppConfig(active = true, dep = null) {
  const [cfg, setCfg] = useState(null);
  useEffect(() => {
    if (!active) return;
    const load = () => api.get("/public/whatsapp").then(({ data }) => setCfg(data)).catch(() => setCfg(null));
    load();
    window.addEventListener("focus", load);
    return () => window.removeEventListener("focus", load);
  }, [active, dep]);
  return cfg;
}

export const waLink = (number, msg) => `https://wa.me/${number}?text=${encodeURIComponent(msg)}`;

export default function WhatsAppButton() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const isPortal = pathname.startsWith("/customer");
  const visible = isPortal || PUBLIC_PATHS.includes(pathname);
  const cfg = useWhatsAppConfig(visible, pathname);

  if (!visible || !cfg?.enabled || !cfg.number) return null;

  const memberId = user?.role === "customer" ? user?.profile?.customer_id || user?.customer_id : null;
  const msg = isPortal && memberId
    ? `Hi Zola, I need help with my rewards. My membership ID is ${memberId}.`
    : VISITOR_MSG;
  const href = waLink(cfg.number, msg);

  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with Zola on WhatsApp"
      title="Chat with Zola on WhatsApp"
      data-testid="whatsapp-float-btn"
      className={`wa-float fixed right-4 md:right-6 md:bottom-6 z-50 grid place-items-center h-14 w-14 rounded-full text-white ${pathname === "/customer" ? "bottom-[148px]" : isPortal ? "bottom-[88px]" : "bottom-5"}`}
      style={{ background: "#25D366", marginBottom: "env(safe-area-inset-bottom, 0px)" }}
    >
      <WhatsAppIcon className="h-7 w-7" />
    </a>
  );
}
